import { onValue, ref } from "firebase/database"
import { useHost } from "global/host.global"
import { useEffect, useState } from "react"
import { realtimeDatabase } from "services/firebase/firebase.service"
import bearing from "utils/bearing"

/**
 *
 * @param path Path to the node eg. starling:base_user/526ad9d8-d642-4b75-a07c-10ad33ca4ca3
 * @returns Location coordinates of the entity along with the turn angle
 * @author Malik Bagwala <malik.bagwala@vesatogo.com>
 * @example
 * import useLiveLocation from "pages/vehicle/trip/useLiveLocation"
 *
 * const { location, angle } = useLiveLocation("starling:base_user/526ad9d8-d642-4b75-a07c-10ad33ca4ca3")
 *
 * <Marker latitude={location.lat} longitude={location.lng}/>
 */
function useLiveLocation(path: string) {
  const { firebaseNode } = useHost()
  const [state, setState] = useState({
    location: { lat: 0, lng: 0 },
    angle: 0,
  })

  useEffect(() => {
    const liveListener = onValue(
      ref(realtimeDatabase, `${firebaseNode}/${path}`),
      data => {
        const item = data.val()
        const newLocation = {
          lat: parseFloat(item?.latitude) || 0,
          lng: parseFloat(item?.longitude) || 0,
        }
        // Calculate the angle to rotate the vehicle.
        // Subtract the newLatLng from prevLatLng to get the vehicle HEADING
        // i.e (the direction where the vehicle is headed)
        setState(prev => ({
          angle: bearing(prev.location, newLocation) || 0,
          location: newLocation,
        }))
      }
    )
    // Remove the listener once this component unmounts
    return function cleanup() {
      return liveListener()
    }
  }, [firebaseNode, path])
  return state
}

export default useLiveLocation
